import { Image, Text, View } from '@react-pdf/renderer';

import { useLayoutEffect, useState } from 'react';

import usePrintHelper from '../../hooks/useHelpers';

const NewBarcode = ({ value, options, textStyles, hideText = false, fullWidth }) => {
	const [barcode, setBarcode] = useState(null);

	const { createBarcode } = usePrintHelper();

	useLayoutEffect(() => {
		const barcode = createBarcode(value, options);

		setBarcode(barcode);
	}, [value, options]);

	return barcode ? (
		<View
			style={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				marginTop: 5,
				marginBottom: 5,
				width: '100%'
			}}>
			<Image
				src={barcode.src}
				style={{
					width: fullWidth ? undefined : barcode.canvasWidth,
					height: fullWidth ? undefined : barcode.canvasHeight,
					objectFit: fullWidth ? undefined : 'scale-down'
				}}
			/>
			{!hideText && <Text style={textStyles}>{value}</Text>}
		</View>
	) : null;
};

export default NewBarcode;
